/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { getBreadcrumbTrail } from '@/data/Content/BreadcrumbTrail-Server';
import { dataMap, fetcher } from '@/data/Content/_BreadcrumbTrail';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { getContractIdParamFromContext, useSettings } from '@/data/Settings';
import { useUser } from '@/data/User';
import { usePageDataFromId } from '@/data/_PageDataFromId';
import { DATA_KEY_BREADCRUMB } from '@/data/constants/dataKey';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { expand, shrink } from '@/data/utils/keyUtil';
import useSWR from 'swr';
import { Breadcrumb } from '../types/Breadcrumb';
import { DYNAMIC_CONTENT_PARENT_PAGE_SEO_URL } from '../constants/pageDataFromId';
import { EMPTY_STRING } from '@/data/constants/marketing';
export { getBreadcrumbTrail };

const getDynamicContentPageBreadCrumb = (x_customField2:string, basePath:string, pageName:string) => {
	let breadcrumb:Breadcrumb[] = [
		{
			label:x_customField2.toLowerCase()
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' '),
			href:`${basePath}/${DYNAMIC_CONTENT_PARENT_PAGE_SEO_URL[x_customField2?.toLocaleLowerCase()]}`
		},
		{
			label:pageName
		}
	];
	return breadcrumb;
}

export const useBreadcrumbTrail = () => {
	const router = useNextRouter();
	const { trail } = router.query;
	const { settings } = useSettings();
	const { user } = useUser();
	const { storeId, langId, defaultCatalogId: catalogId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();	
	const { data: pageData } = usePageDataFromId();
	const { tokenName = '', tokenValue = '', tokenExternalValue = '', x_customField2 = '' } = pageData ?? {};
	let pageName = tokenExternalValue;
	let categoryCanonicalDefault=null;
	if(pageData?.page?.type?.includes("SearchPage")){
		pageName = "SearchPage";
	}
	if(pageData?.tokenName?.includes("CategoryToken")){
		categoryCanonicalDefault = '/'+pageData?.identifier
	}
	const { data, error } = useSWR(
		tokenName && storeId
			? [
					shrink({
						trail,
						tokenName,
						tokenValue,
						tokenExternalValue,
						storeId,
						catalogId,
						langId,
						...getContractIdParamFromContext(user?.context),
					}),
					DATA_KEY_BREADCRUMB,
			  ]
			: null,
		async ([props]) => dataMap(await fetcher(true)(expand(props), params), settings.userData.SiteLink_DomainName,trail as string[])
	);
	let breadcrumb = data?.rc;
	if(tokenName==="StaticPagesToken" && x_customField2 && x_customField2!==EMPTY_STRING){
		breadcrumb = getDynamicContentPageBreadCrumb(x_customField2, settings.userData.SiteLink_DomainName, pageName);
	}
	return { 
		breadcrumb: breadcrumb, 
		uniqueId: tokenValue, 
		categoryCanonicalPath:data?.categoryCanonicalPath??categoryCanonicalDefault,
		pageName,
		error
	};
};